var Wenprise = Wenprise || {};

(function ($) {

    "use strict";

    // 初始化对象
    Wenprise.initialize = {

        /*******************************************************
         // 初始化方法，把其他方法包含进来
         /*******************************************************/
        init: function () {
            Wenprise.initialize.matchHeight();
            Wenprise.initialize.responsiveClasses();
            Wenprise.initialize.imagePreload('.portfolio-item:not(:has(.fslider)) img');
            Wenprise.initialize.pageLoader();
            Wenprise.initialize.runPopUp();
            //Wenprise.initialize.ajaxLoader();
            Wenprise.initialize.runAnimation();
            Wenprise.initialize.runTextAnimation();
            Wenprise.initialize.runSliders();
            Wenprise.initialize.goToTop();
            Wenprise.initialize.lazyLoad();
            Wenprise.initialize.verticalMiddle();
            Wenprise.initialize.lightbox();
            Wenprise.initialize.runGallerySlider();
            //Wenprise.initialize.mobileSidebar();
        },

        /*******************************************************
         * 等高布局
         *******************************************************/
        matchHeight: function () {
            $('.f-match-height').matchHeight()
        },


        /**********************************************************
         * 自适应类，和 CSS 中的端点一致
         **********************************************************/
        responsiveClasses: function () {

            if (typeof jRespond === 'undefined') {
                console.log('responsiveClasses: jRespond not Defined.');
                return true;
            }

            var jRes = jRespond([{
                label: 'smallest',
                enter: 0,
                exit : 479
            },
                {
                    label: 'handheld',
                    enter: 480,
                    exit : 767
                },
                {
                    label: 'tablet',
                    enter: 768,
                    exit : 991
                },
                {
                    label: 'laptop',
                    enter: 992,
                    exit : 1199
                },
                {
                    label: 'desktop',
                    enter: 1200,
                    exit : 10000
                }]);
            jRes.addFunc([{
                breakpoint: 'desktop',
                enter     : function () {
                    $body.addClass('device-lg');
                },
                exit      : function () {
                    $body.removeClass('device-lg');
                }
            },
                {
                    breakpoint: 'laptop',
                    enter     : function () {
                        $body.addClass('device-md');
                    },
                    exit      : function () {
                        $body.removeClass('device-md');
                    }
                },
                {
                    breakpoint: 'tablet',
                    enter     : function () {
                        $body.addClass('device-sm');
                    },
                    exit      : function () {
                        $body.removeClass('device-sm');
                    }
                },
                {
                    breakpoint: 'handheld',
                    enter     : function () {
                        $body.addClass('device-xs');
                    },
                    exit      : function () {
                        $body.removeClass('device-xs');
                    }
                },
                {
                    breakpoint: 'smallest',
                    enter     : function () {
                        $body.addClass('device-xxs');
                    },
                    exit      : function () {
                        $body.removeClass('device-xxs');
                    }
                }]);
        },


        /**********************************************************
         * 图片预加载
         **********************************************************/
        imagePreload: function (selector, parameters) {
            var params = {
                delay     : 250,
                transition: 400,
                easing    : 'linear'
            };
            $.extend(params, parameters);

            $(selector).each(function () {
                var image = $(this);
                image.css({
                    visibility: 'hidden',
                    opacity   : 0,
                    display   : 'block'
                });
                image.wrap('<span class="preloader" />');
                image.one("load", function (evt) {
                    $(this).delay(params.delay).css({visibility: 'visible'}).animate({opacity: 1}, params.transition, params.easing, function () {
                        $(this).unwrap('<span class="preloader" />');
                    });
                }).each(function () {
                    if (this.complete) {
                        $(this).trigger("load");
                    }
                });
            });
        },


        /*******************************************************
         *页面加载动画
         *******************************************************/
        pageLoader: function () {
            $('#loader').fadeOut();
        },


        /*******************************************************
         *图片弹窗
         *******************************************************/
        runPopUp: function () {
            $popup.each(function () {

                var items = [],
                    image = '';

                $(this).find('.image').each(function () {
                    var item = {};
                    image = $(this).find('img').attr('src');
                    item.src = image;
                    items.push(item);
                });

                $(this).find('.f-gallery').magnificPopup({
                    items  : items,
                    type   : 'image',
                    gallery: {
                        enabled           : true,
                        navigateByImgClick: true
                    }
                });
            });
        },


        /*******************************************************
         * Ajax 加载更多
         *******************************************************/
        //ajaxLoader: function () {
        //
        //    var $content = $('.m-ajax-posts');
        //    var $loader = $('#f-more-posts');
        //    var cat = $loader.data('category');
        //    var ppp = screenReaderText.ppp;
        //
        //    $content.imagesLoaded(function () {
        //        $content.masonry({
        //            itemSelector: '.grid-item'
        //        });
        //    });
        //
        //    $loader.on('click', load_ajax_posts);
        //
        //    function load_ajax_posts() {
        //        if (!($loader.hasClass('loading') || $loader.hasClass('post_no_more_posts'))) {
        //            var offset = $content.find('.grid-item').length;
        //            $.ajax({
        //                type      : 'POST',
        //                dataType  : 'html',
        //                url       : screenReaderText.ajaxurl,
        //                data      : {
        //                    'ppp'   : ppp,
        //                    'offset': offset,
        //                    'action': 'wprs_more_post_ajax'
        //                },
        //                beforeSend: function () {
        //                    $loader.button('loading');
        //                },
        //                success   : function (data) {
        //                    var $data = $(data);
        //                    if ($data.length) {
        //                        var $newElements = $data.addClass('animated zoomIn');
        //                        $content.append($newElements).each(function () {
        //                            $content.imagesLoaded(function () {
        //                                $content.masonry({
        //                                    itemSelector: '.grid-item'
        //                                });
        //
        //                            });
        //                            $content.masonry('reloadItems');
        //                        });
        //                        $newElements.animate({opacity: 1});
        //                        $content.masonry();
        //                        $loader.button('reset');
        //                    } else {
        //                        $loader.removeClass('loading').addClass('post_no_more_posts').html(screenReaderText.noposts);
        //                    }
        //                },
        //                error     : function (jqXHR, textStatus, errorThrown) {
        //                    $loader.html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
        //                    console.log(jqXHR);
        //                }
        //            });
        //        }
        //
        //        offset += ppp;
        //        return false;
        //    }
        //
        //},


        /*******************************************************
         // CSS 3 动画
         /*******************************************************/
        runAnimation: function () {
            $('*').each(function () {
                if ($(this).attr('data-animation')) {
                    var $animationName = $(this).attr('data-animation'),
                        $animationDelay = "delay-" + $(this).attr('data-animation-delay');
                    $(this).appear(function () {
                        $(this).addClass('animated').addClass($animationName);
                        $(this).addClass('animated').addClass($animationDelay);
                    });
                }
            });
        },


        /*******************************************************
         *文字动画
         *******************************************************/
        runTextAnimation: function () {
            $('.tlt').textillate({
                loop: true,
                in  : {
                    effect    : 'fadeInUp',
                    delayScale: 2,
                    delay     : 50,
                    sync      : false,
                    shuffle   : false,
                    reverse   : true
                },
                out : {
                    effect    : 'fadeOutUp',
                    delayScale: 2,
                    delay     : 50,
                    sync      : false,
                    shuffle   : false,
                    reverse   : true
                }
            });
        },


        /*******************************************************
         * Slider 和 Carousel
         *******************************************************/
        runSliders: function () {
            $slider.slick();
        },


        /*******************************************************
         * 产品相册幻灯
         *******************************************************/
        runGallerySlider: function () {
            $('.u-gallery-image').slick({
                slidesToShow  : 1,
                slidesToScroll: 1,
                arrows        : false,
                fade          : true,
                asNavFor      : '.u-gallery-nav'
            });
            $('.u-gallery-nav').slick({
                slidesToShow  : 3,
                slidesToScroll: 1,
                asNavFor      : '.u-gallery-image',
                dots          : false,
                centerMode    : true,
                focusOnSelect : true
            });
        },


        /*******************************************************
         * 移动端侧边栏
         *******************************************************/
        mobileSidebar: function () {

            // 根据需要移动侧边栏和页脚位置
            if ($body.hasClass('device-xxs') || $body.hasClass('device-xs') || $body.hasClass('device-sm')) {
                $('.f-close-sidebar').remove();
                $('.f-close-footer').remove();
                $("#sidebar").insertAfter($wrapper).attr('off-canvas', 'sidebar right push').prepend('<a class="delete f-close-sidebar"></a>');
                $footer.insertAfter($wrapper).attr('off-canvas', 'footer bottom reveal').prepend('<a class="delete f-close-footer"></a>');
            } else {
                $("#sidebar").insertAfter('#primary').removeAttr('off-canvas').removeAttr('style').find('a.delete').remove();
                $footer.removeAttr('off-canvas').removeAttr('style').find('a.delete').remove();
            }

            var controller = new slidebars();
            controller.init();

            // 左右侧边栏开关
            //$( '.f-open-sidebar' ).bind( 'click', function ( event ) {
            //    event.stopPropagation();
            //    controller.toggle( 'sidebar' );
            //} );
            //
            //$( '.f-close-sidebar' ).bind( 'click', function ( event ) {
            //    event.preventDefault();
            //    event.stopPropagation();
            //    controller.close( 'sidebar' );
            //} );

            // 底部开关
            //$( '.f-open-footer' ).bind( 'click', function ( event ) {
            //    event.stopPropagation();
            //    controller.open( 'footer' );
            //} );
            //
            //$( '.f-close-footer' ).bind( 'click', function ( event ) {
            //    event.preventDefault();
            //    event.stopPropagation();
            //    controller.close( 'footer' );
            //} );

            // Add close class to canvas container when Slidebar is opened
            //$( controller.events ).on( 'opening', function ( event ) {
            //    $( '[canvas]' ).addClass( 'js-close-any1' );
            //
            //    // 先移除再添加，避免缩放窗口时重复添加
            //    $('#f-sidebar-mask').remove();
            //    $body.append('<div id="f-sidebar-mask" class="modal-background f-no-scroll"></div>').addClass('f-no-scroll');
            //} );
            //
            //// Add close class to canvas container when Slidebar is opened
            //$( controller.events ).on( 'closing', function ( event ) {
            //    $( '[canvas]' ).removeClass( 'js-close-any1' );
            //    $('#f-sidebar-mask').remove();
            //    $body.removeClass('f-no-scroll');
            //} );
            //
            //$('.js-close-any').bind( 'click', function ( event ) {
            //    if ( controller.getActiveSlidebar() ) {
            //        event.preventDefault();
            //        event.stopPropagation();
            //        controller.close();
            //    }
            //} );
        },


        /**********************************************************
         * 到顶部间距
         **********************************************************/
        topScrollOffset: function () {
            var topOffsetScroll = 0;

            if (($body.hasClass('device-lg') || $body.hasClass('device-md')) && !Wenprise.isMobile.any()) {
                if ($header.hasClass('sticky-header')) {
                    if ($pagemenu.hasClass('dots-menu')) {
                        topOffsetScroll = 100;
                    } else {
                        topOffsetScroll = 144;
                    }
                } else {
                    if ($pagemenu.hasClass('dots-menu')) {
                        topOffsetScroll = 140;
                    } else {
                        topOffsetScroll = 184;
                    }
                }

                if (!$pagemenu.length) {
                    if ($header.hasClass('sticky-header')) {
                        topOffsetScroll = 100;
                    } else {
                        topOffsetScroll = 140;
                    }
                }
            } else {
                topOffsetScroll = 40;
            }

            return topOffsetScroll;
        },


        /**********************************************************
         * 定义列宽
         **********************************************************/
        defineColumns: function (element) {
            var column = 4;

            if (element.hasClass('portfolio-full')) {
                if (element.hasClass('portfolio-3')) {
                    column = 3;
                } else if (element.hasClass('portfolio-5')) {
                    column = 5;
                } else if (element.hasClass('portfolio-6')) {
                    column = 6;
                } else {
                    column = 4;
                }

                if ($body.hasClass('device-sm') && (column === 4 || column === 5 || column === 6)) {
                    column = 3;
                } else if ($body.hasClass('device-xs') && (column === 3 || column === 4 || column === 5 || column === 6)) {
                    column = 2;
                } else if ($body.hasClass('device-xxs')) {
                    column = 1;
                }
            } else if (element.hasClass('masonry-thumbs')) {

                var lgCol = element.attr('data-lg-col'),
                    mdCol = element.attr('data-md-col'),
                    smCol = element.attr('data-sm-col'),
                    xsCol = element.attr('data-xs-col'),
                    xxsCol = element.attr('data-xxs-col');

                if (element.hasClass('col-2')) {
                    column = 2;
                } else if (element.hasClass('col-3')) {
                    column = 3;
                } else if (element.hasClass('col-5')) {
                    column = 5;
                } else if (element.hasClass('col-6')) {
                    column = 6;
                } else {
                    column = 4;
                }

                if ($body.hasClass('device-lg')) {
                    if (lgCol) {
                        column = Number(lgCol);
                    }
                } else if ($body.hasClass('device-md')) {
                    if (mdCol) {
                        column = Number(mdCol);
                    }
                } else if ($body.hasClass('device-sm')) {
                    if (smCol) {
                        column = Number(smCol);
                    }
                } else if ($body.hasClass('device-xs')) {
                    if (xsCol) {
                        column = Number(xsCol);
                    }
                } else if ($body.hasClass('device-xxs')) {
                    if (xxsCol) {
                        column = Number(xxsCol);
                    }
                }

            }

            return column;
        },


        /**********************************************************
         * 设置全宽列宽
         **********************************************************/
        setFullColumnWidth: function (element) {

            if (!$().isotope) {
                console.log('setFullColumnWidth: Isotope not Defined.');
                return true;
            }

            element.css({'width': ''});

            var columns = Wenprise.initialize.defineColumns(element);
            var containerWidth = element.width();
            var postWidth = Math.floor(containerWidth / columns);

            if (element.hasClass('portfolio-full')) {

                if (containerWidth === (Math.floor(containerWidth / columns) * columns)) {
                    containerWidth = containerWidth - 1;
                }

                postWidth = Math.floor(containerWidth / columns);

                var deviceSmallest = 0;
                if ($body.hasClass('device-xxs')) {
                    deviceSmallest = 1;
                }

                element.find(".grid-item").each(function () {
                    var elementSize = postWidth;
                    if (deviceSmallest === 0 && $(this).hasClass('wide')) {
                        elementSize = (postWidth * 2);
                    }
                    $(this).css({"width": elementSize + "px"});
                });

            } else if (element.hasClass('masonry-thumbs')) {

                containerWidth = element.innerWidth();

                if (containerWidth === windowWidth) {
                    containerWidth = windowWidth * 1.004;
                    element.css({'width': containerWidth + 'px'});
                }

                postWidth = (containerWidth / columns);

                postWidth = Math.floor(postWidth);

                if ((postWidth * columns) >= containerWidth) {
                    element.css({'margin-right': '-1px'});
                }

                element.children('a').css({"width": postWidth + "px"});

                var firstElementWidth = element.find('a:eq(0)').outerWidth();

                element.isotope({
                    masonry: {
                        columnWidth: firstElementWidth
                    }
                });

                var bigImageNumbers = element.attr('data-big');
                if (bigImageNumbers) {
                    bigImageNumbers = bigImageNumbers.split(",");

                    var bigImageNumber = '',
                        bigi;

                    for (bigi = 0; bigi < bigImageNumbers.length; bigi++) {
                        bigImageNumber = Number(bigImageNumbers[bigi]) - 1;
                        element.find('a:eq(' + bigImageNumber + ')').css({width: firstElementWidth * 2 + 'px'});
                    }

                    var t = setTimeout(function () {
                        element.isotope('layout');
                    }, 1000);
                }
            }

        },


        /**********************************************************
         * 灯箱
         **********************************************************/
        lightbox: function () {

            if (!$().magnificPopup) {
                console.log('lightbox: Magnific Popup not Defined.');
                return true;
            }

            var $lightboxImageEl = $('[data-lightbox="image"]'),
                $lightboxGalleryEl = $('[data-lightbox="gallery"]'),
                $lightboxIframeEl = $('[data-lightbox="iframe"]'),
                $lightboxInlineEl = $('[data-lightbox="inline"]'),
                $lightboxAjaxEl = $('[data-lightbox="ajax"]'),
                $lightboxAjaxGalleryEl = $('[data-lightbox="ajax-gallery"]');

            if ($lightboxImageEl.length > 0) {
                $lightboxImageEl.magnificPopup({
                    type               : 'image',
                    closeOnContentClick: true,
                    closeBtnInside     : false,
                    fixedContentPos    : true,
                    mainClass          : 'mfp-no-margins mfp-fade', // class to remove default margin from left and right side
                    image              : {
                        verticalFit: true
                    }
                });
            }

            if ($lightboxGalleryEl.length > 0) {
                $lightboxGalleryEl.each(function () {
                    var element = $(this);

                    if (element.find('a[data-lightbox="gallery-item"]').parent('.clone').hasClass('clone')) {
                        element.find('a[data-lightbox="gallery-item"]').parent('.clone').find('a[data-lightbox="gallery-item"]').attr('data-lightbox', '');
                    }

                    if (element.find('a[data-lightbox="gallery-item"]').parents('.cloned').hasClass('cloned')) {
                        element.find('a[data-lightbox="gallery-item"]').parents('.cloned').find('a[data-lightbox="gallery-item"]').attr('data-lightbox', '');
                    }

                    element.magnificPopup({
                        delegate           : 'a[data-lightbox="gallery-item"]',
                        type               : 'image',
                        closeOnContentClick: true,
                        closeBtnInside     : false,
                        fixedContentPos    : true,
                        mainClass          : 'mfp-no-margins mfp-fade', // class to remove default margin from left and right side
                        image              : {
                            verticalFit: true
                        },
                        gallery            : {
                            enabled           : true,
                            navigateByImgClick: true,
                            preload           : [0,
                                1] // Will preload 0 - before current, and 1 after the current image
                        }
                    });
                });
            }

            if ($lightboxIframeEl.length > 0) {
                $lightboxIframeEl.magnificPopup({
                    disableOn      : 600,
                    type           : 'iframe',
                    removalDelay   : 160,
                    preloader      : false,
                    fixedContentPos: false
                });
            }

            if ($lightboxInlineEl.length > 0) {
                $lightboxInlineEl.magnificPopup({
                    type           : 'inline',
                    mainClass      : 'mfp-no-margins mfp-fade',
                    closeBtnInside : false,
                    fixedContentPos: true,
                    overflowY      : 'scroll'
                });
            }

            if ($lightboxAjaxEl.length > 0) {
                $lightboxAjaxEl.magnificPopup({
                    type          : 'ajax',
                    closeBtnInside: false,
                    callbacks     : {
                        ajaxContentAdded: function () {
                            Wenprise.initialize.resizeVideos();
                            Wenprise.widget.masonryThumbs();
                        },
                        open            : function () {
                            $body.addClass('ohidden');
                        },
                        close           : function () {
                            $body.removeClass('ohidden');
                        }
                    }
                });
            }

            if ($lightboxAjaxGalleryEl.length > 0) {
                $lightboxAjaxGalleryEl.magnificPopup({
                    delegate      : 'a[data-lightbox="ajax-gallery-item"]',
                    type          : 'ajax',
                    closeBtnInside: false,
                    gallery       : {
                        enabled           : true,
                        preload           : 0,
                        navigateByImgClick: false
                    },
                    callbacks     : {
                        ajaxContentAdded: function () {
                            Wenprise.initialize.resizeVideos();
                            Wenprise.widget.masonryThumbs();
                        },
                        open            : function () {
                            $body.addClass('ohidden');
                        },
                        close           : function () {
                            $body.removeClass('ohidden');
                        }
                    }
                });
            }
        },


        /**********************************************************
         * 评语栅格
         **********************************************************/
        testimonialsGrid: function () {
            if ($testimonialsGridEl.length > 0) {
                if ($body.hasClass('device-sm') || $body.hasClass('device-md') || $body.hasClass('device-lg')) {
                    var maxHeight = 0;
                    $testimonialsGridEl.each(function () {
                        $(this).find("li > .testimonial").each(function () {
                            if ($(this).height() > maxHeight) {
                                maxHeight = $(this).height();
                            }
                        });
                        $(this).find("li").height(maxHeight);
                        maxHeight = 0;
                    });
                } else {
                    $testimonialsGridEl.find("li").css({'height': 'auto'});
                }
            }
        },


        /**********************************************************
         * 视频缩放
         **********************************************************/
        resizeVideos: function () {

            if (!$().fitVids) {
                console.log('resizeVideos: FitVids not Defined.');
                return true;
            }

            $("#content,#footer,#slider:not(.revslider-wrap),.landing-offer-media,.portfolio-ajax-modal,.mega-menu-column").fitVids({
                customSelector: "iframe[src^='http://www.dailymotion.com/embed'], iframe[src*='maps.google.com'], iframe[src*='google.com/maps']",
                ignore        : '.no-fv'
            });
        },


        /**********************************************************
         * 图片渐显
         **********************************************************/
        imageFade: function () {
            $('.image_fade').hover(function () {
                $(this).filter(':not(:animated)').animate({opacity: 0.8}, 400);
            }, function () {
                $(this).animate({opacity: 1}, 400);
            });
        },


        /**********************************************************
         * 博客时间线内容
         **********************************************************/
        blogTimelineEntries: function () {
            $('.post-timeline.grid-2').find('.entry').each(function () {
                var position = $(this).inlineStyle('left');
                if (position === '0px') {
                    $(this).removeClass('alt');
                } else {
                    $(this).addClass('alt');
                }
                $(this).find('.entry-timeline').fadeIn();
            });
        },


        /**********************************************************
         * 懒加载
         **********************************************************/
        lazyLoad: function () {
            var lazyLoadEl = $('[data-lazyload]');
            if (lazyLoadEl.length > 0) {
                lazyLoadEl.each(function () {
                    var element = $(this), elementImg = element.attr('data-lazyload');

                    element.attr('src', 'images/blank.svg').css({'background': 'url(images/preloader.gif) no-repeat center center #FFF'});

                    element.appear(function () {
                        element.css({'background': 'none'}).removeAttr('width').removeAttr('height').attr('src', elementImg);
                    }, {
                        accX: 0,
                        accY: 120
                    }, 'easeInCubic');
                });
            }
        },


        /**********************************************************
         * 垂直居中
         **********************************************************/
        verticalMiddle: function () {
            if ($verticalMiddleEl.length > 0) {
                $verticalMiddleEl.each(function () {
                    var element = $(this), verticalMiddleH = element.outerHeight(), headerHeight = $header.outerHeight();

                    if (element.parents('#slider').length > 0 && !element.hasClass('ignore-header')) {
                        if ($header.hasClass('transparent-header') && ($body.hasClass('device-lg') || $body.hasClass('device-md'))) {
                            verticalMiddleH = verticalMiddleH - 70;
                            if ($slider.next('#header').length > 0) {
                                verticalMiddleH = verticalMiddleH + headerHeight;
                            }
                        }
                    }

                    if ($body.hasClass('device-xs') || $body.hasClass('device-xxs')) {
                        if (element.parents('.full-screen').length && !element.parents('.force-full-screen').length) {
                            if (element.children('.col-padding').length > 0) {
                                element.css({
                                    position : 'relative',
                                    top      : '0',
                                    width    : 'auto',
                                    marginTop: '0'
                                }).addClass('clearfix');
                            } else {
                                element.css({
                                    position     : 'relative',
                                    top          : '0',
                                    width        : 'auto',
                                    marginTop    : '0',
                                    paddingTop   : '60px',
                                    paddingBottom: '60px'
                                }).addClass('clearfix');
                            }
                        } else {
                            element.css({
                                position     : 'absolute',
                                top          : '50%',
                                width        : '100%',
                                paddingTop   : '0',
                                paddingBottom: '0',
                                marginTop    : -(verticalMiddleH / 2) + 'px'
                            });
                        }
                    } else {
                        element.css({
                            position     : 'absolute',
                            top          : '50%',
                            width        : '100%',
                            paddingTop   : '0',
                            paddingBottom: '0',
                            marginTop    : -(verticalMiddleH / 2) + 'px'
                        });
                    }
                });
            }
        },


        /**********************************************************
         * 小屏幕上的固定页脚
         **********************************************************/
        stickFooterOnSmall: function () {
            var windowH = $window.height(),
                wrapperH = $wrapper.height();

            if (!$body.hasClass('sticky-footer') && $footer.length > 0 && $wrapper.has('#footer')) {
                if (windowH > wrapperH) {
                    $footer.css({'margin-top': (windowH - wrapperH)});
                }
            }
        },


        /*******************************************************
         * 固定页脚
         *******************************************************/
        stickyFooter: function () {
            if ($body.hasClass('sticky-footer') && $footer.length > 0 && ($body.hasClass('device-lg') || $body.hasClass('device-md'))) {
                var stickyFooter = $footer.outerHeight();
                $content.css({'margin-bottom': stickyFooter});
            } else {
                $content.css({'margin-bottom': 0});
            }
        },


        /**********************************************************
         * 回到顶部
         **********************************************************/
        goToTop: function () {
            var elementScrollSpeed = $goToTopEl.attr('data-speed'),
                elementScrollEasing = $goToTopEl.attr('data-easing');

            if (!elementScrollSpeed) {
                elementScrollSpeed = 700;
            }
            if (!elementScrollEasing) {
                elementScrollEasing = 'easeOutQuad';
            }

            $goToTopEl.click(function () {
                $('body,html').stop(true).animate({
                    'scrollTop': 0
                }, Number(elementScrollSpeed), elementScrollEasing);
                return false;
            });
        },


        /**********************************************************
         * 滚回到顶部
         **********************************************************/
        goToTopScroll: function () {
            var elementMobile = $goToTopEl.attr('data-mobile'),
                elementOffset = $goToTopEl.attr('data-offset');

            if (!elementOffset) {
                elementOffset = 450;
            }

            if (elementMobile !== 'true' && ($body.hasClass('device-xs') || $body.hasClass('device-xxs'))) {
                return true;
            }

            if ($window.scrollTop() > Number(elementOffset)) {
                $goToTopEl.fadeIn();
            } else {
                $goToTopEl.fadeOut();
            }
        },


        /**********************************************************
         * 子元素等高
         **********************************************************/
        maxHeight: function () {
            if ($commonHeightEl.length > 0) {
                if ($commonHeightEl.hasClass('customjs')) {
                    return true;
                }
                $commonHeightEl.each(function () {
                    var element = $(this);
                    if (element.find('.common-height').length > 0) {
                        Wenprise.initialize.commonHeight(element.find('.common-height:not(.customjs)'));
                    }

                    Wenprise.initialize.commonHeight(element);
                });
            }
        },


        /**********************************************************
         * 普通高度
         **********************************************************/
        commonHeight: function (element) {
            var maxHeight = 0;
            element.children('[class*=col-]').each(function () {
                var element = $(this).children();
                if (element.hasClass('max-height')) {
                    maxHeight = element.outerHeight();
                } else {
                    if (element.outerHeight() > maxHeight) {
                        maxHeight = element.outerHeight();
                    }
                }
            });

            element.children('[class*=col-]').each(function () {
                $(this).height(maxHeight);
            });
        }

    };


    /**********************************************************
     * 作品集需要的事件
     **********************************************************/
    Wenprise.portfolio = {

        init: function () {

            Wenprise.portfolio.ajaxload();

        },

        /*******************************************************
         * 删格布局
         *******************************************************/
        gridInit: function ($container) {

            if (!$().isotope) {
                console.log('gridInit: Isotope not Defined.');
                return true;
            }

            if ($container.length < 1) {
                return true;
            }
            if ($container.hasClass('customjs')) {
                return true;
            }

            $container.each(function () {
                var element = $(this),
                    elementTransition = element.attr('data-transition'),
                    elementLayoutMode = element.attr('data-layout'),
                    elementStagger = element.attr('data-stagger');

                if (!elementTransition) {
                    elementTransition = '0.65s';
                }
                if (!elementLayoutMode) {
                    elementLayoutMode = 'masonry';
                }
                if (!elementStagger) {
                    elementStagger = 0;
                }

                setTimeout(function () {
                    if (element.hasClass('portfolio')) {
                        element.isotope({
                            layoutMode        : elementLayoutMode,
                            transitionDuration: elementTransition,
                            stagger           : Number(elementStagger),
                            masonry           : {
                                columnWidth: element.find('.grid-item:not(.wide)')[0]
                            }
                        });
                    } else {
                        element.isotope({
                            layoutMode        : elementLayoutMode,
                            transitionDuration: elementTransition
                        });
                    }
                }, 300);
            });
        },

        /*******************************************************
         * 过滤器
         *******************************************************/
        filterInit: function () {

            if (!$().isotope) {
                console.log('filterInit: Isotope not Defined.');
                return true;
            }

            if ($portfolioFilter.length < 1) {
                return true;
            }
            if ($portfolioFilter.hasClass('customjs')) {
                return true;
            }

            $portfolioFilter.each(function () {
                var element = $(this),
                    elementContainer = element.attr('data-container'),
                    elementActiveClass = element.attr('data-active-class'),
                    elementDefaultFilter = element.attr('data-default');

                if (!elementActiveClass) {
                    elementActiveClass = 'is-success';
                }

                element.find('a').click(function () {
                    element.parent().find('.is-success').removeClass(elementActiveClass);
                    $(this).addClass(elementActiveClass);
                    var selector = $(this).attr('data-filter');
                    $(elementContainer).isotope({filter: selector});
                    return false;
                });

                if (elementDefaultFilter) {
                    element.find('li').removeClass(elementActiveClass);
                    element.find('[data-filter="' + elementDefaultFilter + '"]').parent('li').addClass(elementActiveClass);
                    $(elementContainer).isotope({filter: elementDefaultFilter});
                }
            });
        },

        /*******************************************************
         * 随机排序
         *******************************************************/
        shuffleInit: function () {

            if (!$().isotope) {
                console.log('shuffleInit: Isotope not Defined.');
                return true;
            }

            var portfolioShuffle = $('.portfolio-shuffle');

            if (portfolioShuffle.length < 1) {
                return true;
            }

            portfolioShuffle.click(function () {
                var element = $(this), elementContainer = element.attr('data-container');

                $(elementContainer).isotope('shuffle');
            });
        },

        /*******************************************************
         * 倒序
         *******************************************************/
        portfolioDescMargin: function () {
            var $portfolioOverlayEl = $('.portfolio-overlay');
            if ($portfolioOverlayEl.length > 0) {
                $portfolioOverlayEl.each(function () {
                    var element = $(this);
                    if (element.find('.portfolio-desc').length > 0) {
                        var portfolioOverlayHeight = element.outerHeight();
                        var portfolioOverlayDescHeight = element.find('.portfolio-desc').outerHeight();

                        var portfolioOverlayIconHeight = 0;
                        if (element.find('a.left-icon').length > 0 || element.find('a.right-icon').length > 0 || element.find('a.center-icon').length > 0) {
                            portfolioOverlayIconHeight = 40 + 20;
                        }
                        var portfolioOverlayMiddleAlign = (portfolioOverlayHeight - portfolioOverlayDescHeight - portfolioOverlayIconHeight) / 2;
                        element.find('.portfolio-desc').css({'margin-top': portfolioOverlayMiddleAlign});
                    }
                });
            }
        },

        /*******************************************************
         * 排序
         *******************************************************/
        arrange: function () {
            if ($portfolio.length > 0) {
                $portfolio.each(function () {
                    var element = $(this);
                    Wenprise.initialize.setFullColumnWidth(element);
                });
            }
        },

        /*******************************************************
         * Ajax 加载
         *******************************************************/
        ajaxload: function () {
            $('.portfolio-ajax .grid-item a.center-icon').click(function (e) {
                var portPostId = $(this).parents('.grid-item').attr('id');
                if (!$(this).parents('.grid-item').hasClass('portfolio-active')) {
                    Wenprise.portfolio.loadItem(portPostId, prevPostPortId);
                }
                e.preventDefault();
            });
        },

        /*******************************************************
         * 下一个上一个
         *******************************************************/
        newNextPrev: function (portPostId) {
            var portNext = Wenprise.portfolio.getNextItem(portPostId);
            var portPrev = Wenprise.portfolio.getPrevItem(portPostId);
            $('#next-portfolio').attr('data-id', portNext);
            $('#prev-portfolio').attr('data-id', portPrev);
        },

        /*******************************************************
         * 加载项目
         *******************************************************/
        loadItem: function (portPostId, prevPostPortId, getIt) {
            if (!getIt) {
                getIt = false;
            }
            var portNext = Wenprise.portfolio.getNextItem(portPostId);
            var portPrev = Wenprise.portfolio.getPrevItem(portPostId);
            if (getIt === false) {
                Wenprise.portfolio.closeItem();
                $portfolioAjaxLoader.fadeIn();
                var portfolioDataLoader = $('#' + portPostId).attr('data-loader');
                $portfolioDetailsContainer.load(portfolioDataLoader, {
                    portid  : portPostId,
                    portnext: portNext,
                    portprev: portPrev
                }, function () {
                    Wenprise.portfolio.initializeAjax(portPostId);
                    Wenprise.portfolio.openItem();
                    $portfolioItems.removeClass('portfolio-active');
                    $('#' + portPostId).addClass('portfolio-active');
                });
            }
        },

        /*******************************************************
         * 关闭项目
         *******************************************************/
        closeItem: function () {
            if ($portfolioDetails && $portfolioDetails.height() > 32) {
                $portfolioAjaxLoader.fadeIn();
                $portfolioDetails.find('#portfolio-ajax-single').fadeOut('600', function () {
                    $(this).remove();
                });
                $portfolioDetails.removeClass('portfolio-ajax-opened');
            }
        },

        /*******************************************************
         * 打开项目
         *******************************************************/
        openItem: function () {
            var noOfImages = $portfolioDetails.find('img').length;
            var noLoaded = 0;

            if (noOfImages > 0) {
                $portfolioDetails.find('img').on('load', function () {
                    noLoaded++;
                    var topOffsetScroll = Wenprise.initialize.topScrollOffset();
                    if (noOfImages === noLoaded) {
                        $portfolioDetailsContainer.css({'display': 'block'});
                        $portfolioDetails.addClass('portfolio-ajax-opened');
                        $portfolioAjaxLoader.fadeOut();
                        var t = setTimeout(function () {
                            Wenprise.initialize.lightbox();
                            Wenprise.initialize.resizeVideos();
                            Wenprise.widget.masonryThumbs();
                            $('html,body').stop(true).animate({
                                'scrollTop': $portfolioDetails.offset().top - topOffsetScroll
                            }, 900, 'easeOutQuad');
                        }, 500);
                    }
                });
            } else {
                var topOffsetScroll = Wenprise.initialize.topScrollOffset();
                $portfolioDetailsContainer.css({'display': 'block'});
                $portfolioDetails.addClass('portfolio-ajax-opened');
                $portfolioAjaxLoader.fadeOut();
                var t = setTimeout(function () {
                    Wenprise.initialize.lightbox();
                    Wenprise.initialize.resizeVideos();
                    Wenprise.widget.masonryThumbs();
                    $('html,body').stop(true).animate({
                        'scrollTop': $portfolioDetails.offset().top - topOffsetScroll
                    }, 900, 'easeOutQuad');
                }, 500);
            }
        },

        /*******************************************************
         * 获取下一个项目
         *******************************************************/
        getNextItem: function (portPostId) {
            var portNext = '';
            var hasNext = $('#' + portPostId).next();
            if (hasNext.length !== 0) {
                portNext = hasNext.attr('id');
            }
            return portNext;
        },

        /*******************************************************
         * 获取上一个项目
         *******************************************************/
        getPrevItem: function (portPostId) {
            var portPrev = '';
            var hasPrev = $('#' + portPostId).prev();
            if (hasPrev.length !== 0) {
                portPrev = hasPrev.attr('id');
            }
            return portPrev;
        },

        /*******************************************************
         * 初始化 Ajax
         *******************************************************/
        initializeAjax: function (portPostId) {
            prevPostPortId = $('#' + portPostId);

            $('#next-portfolio, #prev-portfolio').click(function () {
                var portPostId = $(this).attr('data-id');
                $portfolioItems.removeClass('portfolio-active');
                $('#' + portPostId).addClass('portfolio-active');
                Wenprise.portfolio.loadItem(portPostId, prevPostPortId);
                return false;
            });

            $('#close-portfolio').click(function () {
                $portfolioDetailsContainer.fadeOut('600', function () {
                    $portfolioDetails.find('#portfolio-ajax-single').remove();
                });
                $portfolioDetails.removeClass('portfolio-ajax-opened');
                $portfolioItems.removeClass('portfolio-active');
                return false;
            });
        }

    };


    /**********************************************************
     * 小工具需要的事件
     **********************************************************/
    Wenprise.widget = {

        init: function () {
            Wenprise.widget.toggles();
            Wenprise.widget.accordions();
            Wenprise.widget.counter();
            Wenprise.widget.navTree();
        },

        /**********************************************************
         * html5 视频
         **********************************************************/
        html5Video: function () {
            var videoEl = $('.video-wrap:has(video)');
            if (videoEl.length > 0) {
                videoEl.each(function () {
                    var element = $(this), elementVideo = element.find('video'),
                        outerContainerWidth = element.outerWidth(),
                        outerContainerHeight = element.outerHeight(),
                        innerVideoWidth = elementVideo.outerWidth(),
                        innerVideoHeight = elementVideo.outerHeight();

                    var innerVideoPosition = (innerVideoHeight - outerContainerHeight) / 2;

                    if (innerVideoHeight < outerContainerHeight) {
                        var videoAspectRatio = innerVideoWidth / innerVideoHeight,
                            newVideoWidth = outerContainerHeight * videoAspectRatio;
                        innerVideoPosition = (newVideoWidth - outerContainerWidth) / 2;
                        elementVideo.css({
                            'width' : newVideoWidth + 'px',
                            'height': outerContainerHeight + 'px',
                            'left'  : -innerVideoPosition + 'px'
                        });
                    } else {

                        elementVideo.css({
                            'width' : innerVideoWidth + 'px',
                            'height': innerVideoHeight + 'px',
                            'top'   : -innerVideoPosition + 'px'
                        });
                    }

                    if (Wenprise.isMobile.any()) {
                        var placeholderImg = elementVideo.attr('poster');

                        if (placeholderImg !== '') {
                            element.append('<div class="video-placeholder" style="background-image: url(' + placeholderImg + ');"></div>');
                        }
                    }
                });
            }
        },

        /**********************************************************
         * Toggles 折叠
         **********************************************************/
        toggles: function () {
            var $toggle = $('.toggle');
            if ($toggle.length > 0) {
                $toggle.each(function () {
                    var element = $(this),
                        elementState = element.attr('data-state');

                    if (elementState !== 'open') {
                        element.children('.togglec').hide();
                    } else {
                        element.children('.togglet').addClass("toggleta");
                    }

                    element.children('.togglet').click(function () {
                        $(this).toggleClass('toggleta').next('.togglec').slideToggle(300);
                        return true;
                    });
                });
            }
        },


        /**********************************************************
         * 手风琴效果
         **********************************************************/
        accordions: function () {
            var $accordionEl = $('.accordion');
            if ($accordionEl.length > 0) {
                $accordionEl.each(function () {
                    var element = $(this),
                        elementState = element.attr('data-state'),
                        accordionActive = element.attr('data-active');

                    if (!accordionActive) {
                        accordionActive = 0;
                    } else {
                        accordionActive = accordionActive - 1;
                    }

                    element.find('.acc_content').hide();

                    if (elementState !== 'closed') {
                        element.find('.acctitle:eq(' + Number(accordionActive) + ')').addClass('acctitlec').next().show();
                    }

                    element.find('.acctitle').click(function () {
                        if ($(this).next().is(':hidden')) {
                            element.find('.acctitle').removeClass('acctitlec').next().slideUp("normal");
                            $(this).toggleClass('acctitlec').next().slideDown("normal");
                        }
                        return false;
                    });
                });
            }
        },


        /**********************************************************
         *计数器
         **********************************************************/
        counter: function () {

            if (!$().appear) {
                console.log('counter: Appear not Defined.');
                return true;
            }

            if (!$().countTo) {
                console.log('counter: countTo not Defined.');
                return true;
            }

            var $counterEl = $('.counter:not(.counter-instant)');
            if ($counterEl.length > 0) {
                $counterEl.each(function () {
                    var element = $(this);
                    var counterElementComma = $(this).find('span').attr('data-comma');
                    counterElementComma = (counterElementComma);
                    if ($body.hasClass('device-lg') || $body.hasClass('device-md')) {
                        element.appear(function () {
                            Wenprise.widget.runCounter(element, counterElementComma);
                            if (element.parents('.common-height')) {
                                Wenprise.initialize.maxHeight();
                            }
                        }, {
                            accX: 0,
                            accY: -120
                        }, 'easeInCubic');
                    } else {
                        Wenprise.widget.runCounter(element, counterElementComma);
                    }
                });
            }
        },

        // 运行计数器
        runCounter: function (counterElement, counterElementComma) {
            if (counterElementComma === true) {
                counterElement.find('span').countTo({
                    formatter: function (value, options) {
                        value = value.toFixed(options.decimals);
                        value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        return value;
                    }
                });
            } else {
                counterElement.find('span').countTo();
            }
        },


        /**********************************************************
         * Masonry 缩略图
         **********************************************************/
        masonryThumbs: function () {
            var $masonryThumbsEl = $('.masonry-thumbs:not(.customjs)');
            if ($masonryThumbsEl.length > 0) {
                $masonryThumbsEl.each(function () {
                    var masonryItemContainer = $(this);
                    Wenprise.widget.masonryThumbsArrange(masonryItemContainer);
                });
            }
        },


        /**********************************************************
         * Masonry 缩略图排序
         **********************************************************/
        masonryThumbsArrange: function (element) {

            if (!$().isotope) {
                console.log('masonryThumbsArrange: Isotope not Defined.');
                return true;
            }

            Wenprise.initialize.setFullColumnWidth(element);
            element.isotope('layout');
        },


        /**********************************************************
         * Accordion 风格的导航树
         **********************************************************/
        navTree: function () {
            var $navTreeEl = $('.widget_nav_menu');
            if ($navTreeEl.length > 0) {
                $navTreeEl.each(function () {

                    var element = $(this),
                        elementSpeed = element.attr('data-speed'),
                        elementEasing = element.attr('data-easing');

                    // 动画速度
                    if (!elementSpeed) {
                        elementSpeed = 250;
                    }

                    // 动画效果
                    if (!elementEasing) {
                        elementEasing = 'swing';
                    }

                    // 添加 sub-menu 类，添加箭头
                    element.find('ul li:has(ul)').addClass('sub-menu');
                    element.find('ul li:has(ul) > a').append('<span class="icon"><i class="iconfont icon-iosarrowdown"></i></span>');

                    // 打开当前菜单的父级
                    element.find('ul li.current_page_ancestor').addClass('active');
                    element.find('ul li.current_page_parent').addClass('active');
                    element.find('ul > li.current_page_item').addClass('active');

                    element.find('ul li.current_page_parent .children').slideDown(Number(elementSpeed), elementEasing);
                    element.find('ul > li.current_page_item .children').slideDown(Number(elementSpeed), elementEasing);
                    element.find('ul > li.current-menu-item .children').slideDown(Number(elementSpeed), elementEasing);

                    element.find('ul li.current_page_parent .sub-menu').slideDown(Number(elementSpeed), elementEasing);
                    element.find('ul > li.current_page_item .sub-menu').slideDown(Number(elementSpeed), elementEasing);
                    element.find('ul > li.current-menu-item .sub-menu').slideDown(Number(elementSpeed), elementEasing);

                    element.find('ul > li.current-menu-item').parent().parent().slideDown(Number(elementSpeed), elementEasing);
                    element.find('ul > li.current-menu-item').parent().parent('li').addClass('active');

                    // 鼠标划过还是点击显示子菜单
                    if (element.hasClass('on-hover')) {
                        element.find('ul li:has(ul):not(.active)').hover(function () {
                            $(this).children('ul').stop(true, true).slideDown(Number(elementSpeed), elementEasing);
                        }, function () {
                            $(this).children('ul').delay(250).slideUp(Number(elementSpeed), elementEasing);
                        });
                    } else {
                        // 如果需要父级菜单不能点击，把点击元素设置为 a
                        element.find('ul li:has(ul) > a .icon').click(function (e) {
                            var childElement = $(this).parent();
                            element.find('ul li').not(childElement.parents()).removeClass('active');
                            childElement.parent().children('ul').slideToggle(Number(elementSpeed), elementEasing, function () {
                                $(this).find('ul').hide();
                                $(this).find('li.active').removeClass('active');
                            });
                            element.find('ul li > ul').not(childElement.parent().children('ul')).not(childElement.parents('ul'))
                                   .slideUp(Number(elementSpeed), elementEasing);
                            childElement.parent('li:has(ul)').toggleClass('active');
                            e.preventDefault();
                        });
                    }
                });
            }
        }

    };


    /**********************************************************
     * 判断是否为移动设备
     **********************************************************/
    Wenprise.isMobile = {
        Android   : function () {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS       : function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera     : function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows   : function () {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any       : function () {
            return (Wenprise.isMobile.Android() || Wenprise.isMobile.BlackBerry() || Wenprise.isMobile.iOS() || Wenprise.isMobile.Opera() || Wenprise.isMobile.Windows());
        }
    };


    /*******************************************************
     * 文档缩放时运行的方法
     *******************************************************/
    Wenprise.documentOnResize = {

        init: function () {

            var t = setTimeout(function () {
                Wenprise.initialize.verticalMiddle();
                Wenprise.initialize.stickyFooter();
                Wenprise.initialize.maxHeight();
                Wenprise.initialize.testimonialsGrid();
                //Wenprise.initialize.mobileSidebar();
                Wenprise.portfolio.arrange();
                Wenprise.portfolio.portfolioDescMargin();
                Wenprise.widget.masonryThumbs();
            }, 500);

            windowWidth = $window.width();

        }
    };


    /*******************************************************
     * 文档准备好时运行的方法
     *******************************************************/
    Wenprise.documentOnReady = {
        init: function () {

            // 全局方法
            Wenprise.initialize.init();

            Wenprise.documentOnReady.windowscroll();

            // 小工具方法
            Wenprise.widget.init();

            // Portfolio 效果
            if ($portfolio.length > 0) {
                Wenprise.portfolio.init();
            }
            Wenprise.portfolio.gridInit($gridContainer);
            Wenprise.portfolio.filterInit();
            Wenprise.portfolio.shuffleInit();
            Wenprise.portfolio.arrange();
            Wenprise.portfolio.portfolioDescMargin();

        },

        windowscroll: function () {
            $window.on('scroll', function () {
                Wenprise.initialize.goToTopScroll();
            });
        }

    };


    /*******************************************************
     // 文档加载完成时运行的方法
     /*******************************************************/
    Wenprise.documentOnLoad = {

        init: function () {
            Wenprise.initialize.pageLoader();
            Wenprise.initialize.maxHeight();
            Wenprise.initialize.testimonialsGrid();
            Wenprise.initialize.verticalMiddle();
            Wenprise.initialize.stickFooterOnSmall();
            Wenprise.initialize.stickyFooter();
            Wenprise.portfolio.gridInit($gridContainer);
            Wenprise.portfolio.filterInit();
            Wenprise.portfolio.shuffleInit();
            Wenprise.portfolio.arrange();
            Wenprise.portfolio.portfolioDescMargin();
            Wenprise.widget.masonryThumbs();
            Wenprise.widget.html5Video();
            Wenprise.widget.masonryThumbs();
        }

    };

    /**********************************************************
     * 类中使用的变量
     **********************************************************/
    var $document = $(document),
        $window = $(window),
        $body = $('body'),
        $wrapper = $('#site'),
        $header = $('#header'),
        $content = $('#content'),
        $footer = $('#footer'),
        windowWidth = $window.width(),
        $slider = $('.f-slider'),
        $popup = $('.f-popup'),
        $gridContainer = $('.grid-container'),
        $portfolio = $('.portfolio'),
        $portfolioItems = $('.portfolio-ajax').find('.grid-item'),
        $portfolioDetails = $('#portfolio-ajax-wrap'),
        $portfolioDetailsContainer = $('#portfolio-ajax-container'),
        $portfolioAjaxLoader = $('#portfolio-ajax-loader'),
        $portfolioFilter = $('.portfolio-filter,.custom-filter'),
        prevPostPortId = '',
        $verticalMiddleEl = $('.vertical-middle'),
        $commonHeightEl = $('.common-height'),
        $testimonialsGridEl = $('.testimonials-grid'),
        $goToTopEl = $('.back-to-top');

    /**********************************************************
     * 页面处于各种状态时对应执行的动作
     **********************************************************/
    $document.ready(Wenprise.documentOnReady.init);
    $window.load(Wenprise.documentOnLoad.init);
    $window.on('resize', Wenprise.documentOnResize.init);

    if (Wenprise.isMobile.any()) {

        /**
         * 导航
         */
        $('.navbar-menu .has-dropdown').append('<span class="js-toggle"><svg t="1534837390427" class="icon" style="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21784" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32"><defs><style type="text/css"></style></defs><path d="M512 596.6 512 596.6 512 596.6l348.4-334.4c8.6-8.4 22.8-8.2 31.6 0.4l61.2 59.8c8.8 8.6 9 22.6 0.4 31L528.2 761.8c-4.4 4.4-10.4 6.4-16.2 6-6 0.2-11.8-1.8-16.2-6L70.4 353.4c-8.6-8.4-8.4-22.4 0.4-31L132 262.6c8.8-8.6 23-8.8 31.6-0.4L512 596.6z" p-id="21785" fill="#ffffff"></path></svg></span>');


        $('.js-toggle').click(function (e) {
            e.preventDefault();

            var $this = $(this),
                $parent =  $this.parent(),
                $subMenu = $this.parent().find('.navbar-dropdown');

            if ($subMenu.is(":visible")) {
                $this.parent().parent().find('.has-dropdown').removeClass('show');
                $subMenu.slideUp(350);
            } else {
                $this.parent().parent().find('.has-dropdown').removeClass('show');
                $this.parent().parent().find('.navbar-dropdown').slideUp(350);
                $this.parent().parent().find('.navbar-dropdown');
                $parent.addClass('show');
                $subMenu.slideToggle(350);
            }

        });

        // 默认打开
        $('.has-dropdown:nth-child(2)').addClass('show').find('.navbar-dropdown').show();
        $('.has-dropdown:nth-child(4)').addClass('show').find('.navbar-dropdown').show();

    }


    var $excerpt = $('.c-media-tops .c-excerpt');

    if($excerpt.height() > 200){
        $excerpt.height(200);
        $excerpt.append('<span class="js-toggle"><svg t="1534837390427" class="icon" style="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21784" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32"><defs><style type="text/css"></style></defs><path d="M512 596.6 512 596.6 512 596.6l348.4-334.4c8.6-8.4 22.8-8.2 31.6 0.4l61.2 59.8c8.8 8.6 9 22.6 0.4 31L528.2 761.8c-4.4 4.4-10.4 6.4-16.2 6-6 0.2-11.8-1.8-16.2-6L70.4 353.4c-8.6-8.4-8.4-22.4 0.4-31L132 262.6c8.8-8.6 23-8.8 31.6-0.4L512 596.6z" p-id="21785" fill="#ffffff"></path></svg></span>')
    }

    $('.c-media-tops .c-excerpt .js-toggle').click(function(){
        $excerpt.toggleClass('is-active');
    });

})(jQuery);